import React from 'react';
import { Link } from 'react-router-dom';
import { OMenuItem } from 'lib/omnibar/types';
import { Container } from 'lib/raul';
import { hrefTitle } from 'lib/utils';
import { APP } from 'lib/strings';

interface Props {
  childPages: OMenuItem[];
  isLoading: boolean;
}

const ListView = ({ childPages, isLoading }: Props) => {
  return (
    <div className="r-flex r-flex-col md:r-flex-row r-flex-wrap r-p-3 md:r-px-9">
      {childPages?.map(({ pageId, title }) => (
        <Link
          key={pageId}
          className="r-pb-3 md:r-pb-6 md:r-mr-6 r-text-center md:r-w-2/5 lg:r-w-3/12"
          to={`/article/${pageId}/${hrefTitle(title)}`}
        >
          <Container
            addShadow
            loading={isLoading}
            title={<h3 className="r-h-10">{title}</h3>}
          >
            <span className="r-text-primary">{APP.LEARN_MORE}</span>
          </Container>
        </Link>
      ))}
    </div>
  );
};

export default ListView;
